import { render, staticRenderFns } from "./custom_offers.vue?vue&type=template&id=64afd970"
import script from "./custom_offers.vue?vue&type=script&lang=js"
export * from "./custom_offers.vue?vue&type=script&lang=js"
import style0 from "./custom_offers.vue?vue&type=style&index=0&id=64afd970&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports